import { useEffect, useRef, useState } from "react";
import { ResumeDoc } from "@/components/resume/ResumeDoc";

export const ScaledDoc = ({ data, template, className, testid }) => {
  const box = useRef(null);
  const inner = useRef(null);
  const [scale, setScale] = useState(0.5);
  const [h, setH] = useState(1056);
  useEffect(() => {
    const ro = new ResizeObserver(() => {
      if (box.current) setScale(box.current.clientWidth / 816);
      if (inner.current) setH(inner.current.offsetHeight);
    });
    box.current && ro.observe(box.current);
    inner.current && ro.observe(inner.current);
    return () => ro.disconnect();
  }, []);
  return (
    <div ref={box} className={className} style={{ height: h * scale }} data-testid={testid}>
      <div ref={inner} style={{ transform: `scale(${scale})`, transformOrigin: "top left", width: 816 }}>
        <ResumeDoc data={data} template={template} />
      </div>
    </div>
  );
};
